var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-header"},[_vm._v("Notas de Despesas da Fonte Pagadora (Funcionários)")]),_c('div',{staticClass:"card-body"},[_c('b-tabs',[_c('b-tab',{attrs:{"title":"Todas Notas de Despesas da Fonte Pagadora"}},[_c('NDEmployeesAll')],1)],1)],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }